import Tooltip from 'components/Tooltip/Tooltip';
import React, { useEffect, useState } from 'react'
import toast from 'react-hot-toast';
import { MdGrading } from 'react-icons/md';
import fetchData from 'utils/fetchData';

export default function EmployeesToOnboard2() {
    const [rows, setRows] = useState([]);

    async function GetData() {
        try {
            var pResponse = await fetchData.Post('/api/OnBoardingTrans/Get', {
                showJobPosition: true
            });
            setRows(pResponse.rows);
        } catch (e) {
            toast.error(e);
        }
    }

    useEffect(() => {
        GetData();
    }, []);

    return (
        <div>
            <div className="datagrid" style={{ maxHeight: "calc(100vh - 160px)" }}>
                <table>
                    <thead>
                        <tr>
                            <th>Action</th>
                            <th>Employee Name</th>
                            <th>Job Position</th>
                        </tr>
                    </thead>
                    <tbody>
                        {rows.map(row => {
                            return <tr>
                                <td className="border-t-0 px-2 align-center border-l-0 border-r text-sm  p-1 relative overflow-visible h-auto">
                                    <div className="flex items-center justify-center inherit overflow-visible">
                                        <div className="flex items-center gap-2 inherit overflow-visible">
                                            <Tooltip text="Give Score">
                                                <a href={'#/employee-to-onboard/' + row.id} className="cursor-pointer flex self-center justify-self-center">
                                                    <MdGrading className="w-5 h-5" />
                                                </a>
                                            </Tooltip>
                                        </div>
                                    </div>
                                </td>
                                <td>
                                    {row.employeeName}
                                </td>
                                <td>
                                    {row.jobPositionName}
                                </td>
                            </tr>
                        })}
                    </tbody>
                </table>
            </div>

        </div>
    )
}
